import React from 'react';
import dayjs from 'dayjs';
import { Avatar, Stack, StackProps, styled, Typography } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import { Note } from 'modules/service-call/types';
import { useIntl } from 'react-intl';
import { ServiceCallAttachmentsAccordion } from './ServiceCallAttachmentsAccordion';

interface ServiceCallNoteProps {
  note: Note
  serviceCallId: string
}

const NoteContainer = styled(Stack)<StackProps>(({ theme }) => ({
  borderColor: theme.palette.grey[400],
  backgroundColor: theme.palette.background.paper,
  borderWidth: 1,
  borderStyle: 'solid',
  borderRadius: 4,
  '& > div:not(:last-child)': {
    borderBottom: '1px solid',
    borderColor: theme.palette.grey[400],
  }
}));

export const ServiceCallNote: React.FC<ServiceCallNoteProps> = ({ note, serviceCallId }) => {
  const { formatMessage } = useIntl();

  return (
    <NoteContainer>
      <Stack padding={2}>
        <Stack direction='row' alignItems='center' gap={2}>
          <Avatar>
            <PersonIcon fontSize='large' />
          </Avatar>
          <Stack>
            <Typography variant='h6'>{formatMessage({ id: 'ServiceCallNote.NoteTitle', defaultMessage: 'Client' })}</Typography>
            <Typography variant='caption'>{dayjs.utc(note.createdOn).fromNow()}</Typography>
          </Stack>
        </Stack>
      </Stack>
      <Stack padding={2} minHeight={150}>
        <Typography variant='body1' component='pre'>{note.message}</Typography>
      </Stack>
      {note.attachments.length !== 0 &&
        <ServiceCallAttachmentsAccordion attachments={note.attachments} serviceCallId={serviceCallId} noteId={note.id} />
      }
    </NoteContainer>
  );
};